import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MapPin } from "lucide-react";

import "./DeliveryHeader.css";

function DeliveryHeader() {

    const navigate = useNavigate();

    

    const [location, setLocation] = useState(
        "Fetching location..."
    );

    useEffect(() => {

        if (!navigator.geolocation) {

            setLocation("Location unavailable");

            return;

        }

        navigator.geolocation.getCurrentPosition(

            async ({ coords }) => {

                try {

                    const response = await fetch(

                        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${coords.latitude}&lon=${coords.longitude}`

                    );

                    const data = await response.json();

                    const area =
                        data.address.suburb ||
                        data.address.neighbourhood ||
                        data.address.city_district ||
                        "";

                    const city =
                        data.address.city ||
                        data.address.town ||
                        data.address.state ||
                        "";

                    setLocation(`${area}, ${city}`);

                }

                catch {

                    setLocation("Current Location");

                }

            }

        );

    }, []);

    return (

        <header className="delivery-header">

            <div className="delivery-header-top">

                <div className="delivery-brand">

                    <div className="brand-name">

                        HomeFoods

                    </div>

                    <div className="delivery-location">

                        <MapPin
                            size={15}
                            strokeWidth={3.5}
                            className="location-icon"
                        />

                        <span>

                            {location}

                        </span>

                    </div>

                </div>

                <div className="delivery-header-icons">

                   <button
    className="hf-notification"
    onClick={() =>
        navigate("/delivery/notifications")
    }
>
    🔔
</button>

                    <button

                        className="hf-profile"

                        onClick={() =>
                            navigate("/delivery/profile")
                        }

                        title="My Profile"

                    >

                        👤

                    </button>

                </div>

            </div>

        </header>

    );

}

export default DeliveryHeader;